import { useKeycloak } from "@react-keycloak/web";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import useFBOApi from "../services/api/useFBOApi";
const FormDataContext = createContext();

export const useFormData = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const { fetchFBOUserProfile } = useFBOApi();

  const [userData, setUserData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    phone: "",
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    associations: [],
    email: "",
    role: [],
  });

  const [isProfileFetched, setIsProfileFetched] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (!initialized || !keycloak.authenticated || isProfileFetched) return;

    try {
      const keycloakProfile = await keycloak.loadUserProfile();
      const userProfile = await fetchFBOUserProfile();
      const roles = keycloak.tokenParsed.realm_access.roles;

      const updatedUserData = {
        ...userData,
        ...keycloakProfile,
        ...userProfile,
        role: roles,
      };

      setUserData(updatedUserData);
      setIsProfileFetched(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, [initialized, keycloak, fetchFBOUserProfile, isProfileFetched, userData]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <FormDataContext.Provider value={{ userData, setUserData }}>
      {children}
    </FormDataContext.Provider>
  );
};
